import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore'
import 'firebase/storage';

const config = {
    apiKey: "AIzaSyBLaxiyZ2nS1KgRBqWe-NY4EG7OzG5fKpE",
    authDomain: "hayward-europe.firebaseapp.com",
    databaseURL: "https://hayward-europe.firebaseio.com",
    projectId: "hayward-europe",
    storageBucket: "hayward-europe.appspot.com",
    messagingSenderId: "345581060525",
    appId: "1:345581060525:web:d6130c641d4436f5c8e124",
    measurementId: "G-C8N9D03DV0"
}
firebase.initializeApp(config)

const fb = firebase;
const fs = firebase.firestore() //firestore database
const auth = firebase.auth()
const currentUser = auth.currentUser
const storage = firebase.storage().ref(); // Base path to storage bucket
// const storageRef = storage.ref('images'); 

// date issue fix according to firebase
const settings = {
    timestampsInSnapshots: true
}
fs.settings(settings)

// firebase collections
const poolsCollection = fs.collection('pools')
const poolsDemoCollection = fs.collection('demo')
const usersCollection = fs.collection('users')
const alarmsCollection = fs.collection('alarms')
const countersCollection = fs.collection('counters')
const tokensCollection = fs.collection('tokens')

export {
    fb,
    db,
    auth,
    currentUser,
    poolsCollection,
    usersCollection,
    alarmsCollection,
    countersCollection,
    tokensCollection,
    storage,
    googleMapsKey,
    poolsDemoCollection
}


// WEBPACK FOOTER //
// ./src/firebaseConfig.js